import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import {AuthorizationService} from "../../services/authorization.service";
import { PersonModel } from 'src/app/models/person/person.model';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnChanges {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  user: null | any;

  @Input()
  iddResponsiblePerson: PersonModel | null = null;
  
  showChangePasswordModal = false;

  get userName() {
    return `${this.user!.firstName} ${this.user!.lastName}`;
  }

  readonly defaultSupportMail = 'service@skeddle.com';
  supportMailLink: string = `mailto:${this.defaultSupportMail}`;

  constructor(
    private router: Router,
    private authorizationService: AuthorizationService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iddResponsiblePerson']) {
      const email = this.iddResponsiblePerson?.email ?? this.defaultSupportMail;
      this.supportMailLink = `mailto:${email}`;
    }
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  };

  openProfile() {
    this.router.navigate(['profile']);
  }

  logout() {
    this.authorizationService.logout();
  }

  openChangePasswordModal() {
    this.showChangePasswordModal = true;
  }
}
